"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzCalendar = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = __importDefault(require("@fullcalendar/react"));
var timegrid_1 = __importDefault(require("@fullcalendar/timegrid"));
var daygrid_1 = __importDefault(require("@fullcalendar/daygrid"));
var list_1 = __importDefault(require("@fullcalendar/list"));
var fr_1 = __importDefault(require("@fullcalendar/core/locales/fr"));
require("./SzCalendar.scss");
exports.SzCalendar = function (_a) {
    var events = _a.events, handleEventClick = _a.handleEventClick, handleEventRender = _a.handleEventRender, handleDayRender = _a.handleDayRender, defaultDate = _a.defaultDate, calendarView = _a.calendarView;
    return (react_1.default.createElement("div", { className: "sz-Calendar position-relative" },
        react_1.default.createElement(react_2.default, { locale: fr_1.default, defaultDate: defaultDate, events: events, defaultView: calendarView, plugins: [daygrid_1.default, timegrid_1.default, list_1.default], weekends: false, eventClick: handleEventClick, eventBorderColor: "#ABAFBF", eventColor: "white", eventRender: handleEventRender, dayRender: handleDayRender, columnHeaderHtml: function (e) {
                var day = e.getDate();
                var weekday = e.toLocaleDateString('fr', { weekday: 'short' });
                var month = e.toLocaleDateString('fr', { month: 'short' });
                var year = e.toLocaleDateString('fr', { year: '2-digit' });
                return "<div><p class=\"mb-0\">" + weekday + "</p><p class=\"text-gray-light\">" + day + " " + month + " " + year + "</p></div>";
            }, eventClassName: "p-3 sz-border-2 rounded-0 my-1 mx-3", displayEventTime: false, header: {
                left: 'prev',
                center: '',
                right: 'next'
            } })));
};
exports.default = exports.SzCalendar;
exports.SzCalendar.defaultProps = {
    calendarView: 'dayGridWeek'
};
